<template>
    <vxe-modal
        class-name="modeal--runlog"
        title="执行日志"
        v-model="isShowJobHis"
        width="840"
        show-zoom
        resize
        :z-index="9999"
        :transfer="true"
    >
        <template #default>
            <div style="display: flex; flex-direction: column; height: 100%">
                <div>
                    <vxe-form>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button @click="freshData">刷新</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="flex: 1; overflow: hidden">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableDataJob"
                        :cell-style="cellStyle"
                        show-overflow
                        min-height="400"
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable2"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="日志" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-search-plus"
                                    @click="viewLog(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="StateName"
                            title="状态"
                            width="100"
                            align="center"
                        ></vxe-column>
                        <vxe-column
                            field="CreatorUserId"
                            title="邮箱"
                            width="160"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="ProcessKey"
                            title="流程ID"
                            width="130"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="流程名称"
                            width="220"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="Abbr"
                            title="机器简称"
                            width="110"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="StartTime"
                            title="开始时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="EndTime"
                            title="结束时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="MachineName"
                            title="机器人"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="EnvironmentName"
                            title="部署环境"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="Key"
                            title="Key"
                            width="160"
                            :visible="false"
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal
        title="日志明细"
        v-model="logForm.iShow"
        width="900"
        maskClosable
        resize
        show-zoom
        :z-index="10000"
        :transfer="true"
    >
        <template #default>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="logForm.dtLog"
                    ref="xTableUser"
                    height="300"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="id"
                        title="序号"
                        width="60"
                    ></vxe-column>
                    <vxe-column title="状态" width="60">
                        <template #default="{ row }">
                            <span>{{
                                row.Level == "Info" ? "信息" : "错误"
                            }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column
                        field="ProcessName"
                        title="流程ID"
                        width="140"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="RobotName"
                        title="机器人"
                        width="160"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="Message"
                        title="信息"
                        width="400"
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="TimeStamp"
                        title="操作时间"
                        width="160"
                    ></vxe-column>
                </vxe-table>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import {
    reactive,
    ref,
    onMounted,
    onUnmounted,
    watch,
    getCurrentInstance,
    defineExpose,
} from "vue";

import { VXETable } from "vxe-table";
import Qs from "qs";
const { proxy } = getCurrentInstance();
const isShowJobHis = ref(false);
const tableDataJob = ref([]);
const tablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
});
const logForm = reactive({
    dtLog: [],
    iShow: false, //显示更新包
    pager: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
    },
});
const cellStyle = ({ row, column }) => {
    if (column.field === "StateName") {
        if (row.StateName === "运行完成") {
            return {
                color: "#008000",
            };
        } else if (row.StateName === "运行异常") {
            return {
                color: "#FF0000",
            };
        } else {
            return {
                color: "#0000FF",
            };
        }
    }
};
const processKey = ref("");
const machineName = ref("");
const freshData = () => {
    findDataJob(processKey.value, machineName.value);
};
const findDataJob = (processid, robotname, isFirstLoad = false) => {
    if (isFirstLoad) {
        tablePager.currentPage = 1;
        tablePager.pageSize = 10;
    }
    processKey.value = processid || processKey.value;
    machineName.value = robotname || machineName.value;

    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: tablePager.currentPage,
        pageSize: tablePager.pageSize,
        searchKey: [
            processKey.value,
            "",
            machineName.value,
            proxy.$store.state.email,
        ],
    };
    proxy.$api.jobManageAPI
        .getJobsList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            tableDataJob.value = res.data.Data.dataTable;
            tablePager.currentPage = res.data.Data.currentPage;
            tablePager.pageSize = res.data.Data.pageSize;
            tablePager.totalResult = res.data.Data.totalResult;
            isShowJobHis.value = true;
            // debugger;
        })
        .catch((error) => {
            console.log(error);
        });
};
const viewLog = (row) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: logForm.pager.currentPage,
        pageSize: logForm.pager.pageSize,
        searchKey: ["", "", "", "", row.Key],
    };
    proxy.$api.jobManageAPI
        .getLogsList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            logForm.dtLog = res.data.Data.dataTable;
            logForm.iShow = true;
        })
        .catch((error) => {
            console.log(error);
        });
};
const handlePageChange = () => {
    findDataJob(processKey.value, machineName.value);
};
defineExpose({ findDataJob });
</script>
<style scoped>
:deep(.vxe-modal--wrapper) {
    z-index: 9999 !important;
}
.modeal--runlog {
    position: relative;
    z-index: 9999;
}
</style>
